var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1899_17071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6671 11.4541H6.33289V14.4534H9.6671V11.4541Z",
    fill: "#CBD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3969 13.8096H5.60308C5.24783 13.8096 4.95987 14.0975 4.95987 14.4528C4.95987 14.808 5.24783 15.096 5.60308 15.096H10.3969C10.7522 15.096 11.0401 14.808 11.0401 14.4528C11.0402 14.0975 10.7522 13.8096 10.3969 13.8096Z",
    fill: "#AFBBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3349 0.904297H1.66515C1.11067 0.904297 0.661163 1.35383 0.661163 1.90828V11.309C0.661163 11.8635 1.11067 12.313 1.66515 12.313H14.3349C14.8894 12.313 15.3388 11.8635 15.3388 11.309V1.90828C15.3388 1.35383 14.8893 0.904297 14.3349 0.904297Z",
    fill: "#CBD6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02375 11.309V1.90828C3.02375 1.3538 3.47326 0.904297 4.02774 0.904297H1.66515C1.11067 0.904297 0.661163 1.35383 0.661163 1.90828V11.309C0.661163 11.8635 1.11067 12.313 1.66515 12.313H4.02774C3.47329 12.313 3.02375 11.8635 3.02375 11.309Z",
    fill: "#AFBBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8678 2.375H2.1322V10.3535H13.8678V2.375Z",
    fill: "#2BC5B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02379 2.375H2.1322V10.3535H3.02379V2.375Z",
    fill: "#00AE95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.7702C8.24127 11.7702 8.43686 11.5746 8.43686 11.3333C8.43686 11.0921 8.24127 10.8965 8 10.8965C7.75873 10.8965 7.56314 11.0921 7.56314 11.3333C7.56314 11.5746 7.75873 11.7702 8 11.7702Z",
    fill: "#465059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6671 12.3135H6.33289V13.0586H9.6671V12.3135Z",
    fill: "#AFBBC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_17071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerPc);
export default __webpack_public_path__ + "static/media/computer-pc.f79dea099bbe84dfabdf24156a2a2b1d.svg";
export { ForwardRef as ReactComponent };